import { render, staticRenderFns } from "./BusinessLocation.vue?vue&type=template&id=1bc7a270&scoped=true&"
import script from "./BusinessLocation.vue?vue&type=script&lang=js&"
export * from "./BusinessLocation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLocation.vue?vue&type=style&index=0&id=1bc7a270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7a270",
  null
  
)

export default component.exports